// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToCartButtonStyles } from "@west/Overrides/Widgets/ProductDetails/ProductDetailsAddToCartButton";
import { color } from "@west/XDL/Utilities";
import { css } from "styled-components";

addToCartButtonStyles.container = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 8px;
    `,
};

addToCartButtonStyles.addToCartWrapper = {
    css: css`
        width: 100%;
        display: flex;
        align-items: flex-end;
        gap: 8px;

        @media print {
            display: none;
        }
    `,
};

addToCartButtonStyles.labelTypo = addToCartButtonStyles.valueTypo = {
    size: 12,
    lineHeight: "16px",
};

addToCartButtonStyles.unitOfMeasureSelect = {
    sizeVariant: "small",
    labelProps: {
        css: css`
            display: none;
        `,
    },
    cssOverrides: {
        formField: css`
            max-width: 96px;
        `,
    },
};

addToCartButtonStyles.button = {
    css: css`
        min-width: 135px;
        width: 100%;
    `,
};

addToCartButtonStyles.qtyDetailsWrapper = {
    css: css`
        display: flex;
        gap: 24px;
        justify-content: flex-start;

        @media print {
            display: none;
        }
    `,
};

addToCartButtonStyles.authenticationPrompt = {
    container: {
        css: css`
            margin-top: 4px;
        `,
    },
};
